module.exports = __webpack_public_path__ + "static/media/ktm-03.26afb9bc.jpg";